"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDidUpdateEffect = void 0;
var react_1 = require("react");
function useDidUpdateEffect(effect, deps) {
    var didMountRef = react_1.useRef(false);
    react_1.useEffect(function () {
        if (didMountRef.current)
            effect();
        else
            didMountRef.current = true;
    }, deps);
}
exports.useDidUpdateEffect = useDidUpdateEffect;
//# sourceMappingURL=useDidUpdateEffect.js.map